jQuery($ => {
  class Dropdown {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._button = this._element.find('.a-dropdown__button');
      this._list = this._element.find('.a-dropdown__list');
      this._options = this._element.find('.a-dropdown__item');

      this._searchTimeout = false;
      this._searchQuery = '';

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._button.on('mousedown', this.handleButtonMousedown);
      this._button.on('keydown', this.handleButtonKeydown);

      this._options.each((_, option) => {
        $(option).find('.a-dropdown__link').on('click', event => {
          this.handleLinkClick(event, option);
        });

        $(option).find('.a-dropdown__link').on('keydown', event => {
          this.handleLinkKeydown(event, option);
        });

        $(option).find('.a-dropdown__link').on('blur', event => {
          this.handleLinkBlur(event, option);
        });
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle List Open
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleListOpen = () => {
      console.log( 'opening...' );
      const $link = this._list.find(".a-dropdown__item:first-child .a-dropdown__link");

      this._element.addClass("a-dropdown--open");
      // this._list.show();
      $link.focus();

      this._element.trigger('open', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle List Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleListClose() {
      this._element.removeClass("a-dropdown--open");
      this._list.hide();

      if (!$(this).is('.a-dropdown__link[href^="#"]')) {
        this._button.focus();
      }

      this._element.trigger('close', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle List Toggle
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleListToggle = () => {
      if (this._element.hasClass('a-dropdown--open')) {
        // this.handleListClose();
      } else {
        this.handleListOpen();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle List Search
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleListSearch(query) {
      const $links = this._element.find(".a-dropdown__link");

      const queryText = query.trim().toLowerCase();

      $links
        .filter(function () {
          const linkText = $(this)
            .text()
            .trim()
            .toLowerCase();
          return linkText.indexOf(queryText) === 0;
        })
        .first()
        .focus();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Button Mousedown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleButtonMousedown = event => {
      event.preventDefault();

      this.handleListToggle();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Button Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleButtonKeydown = event => {
      switch (event.key) {
        case "Enter":
        case "spacebar":
        case " ":
        case "ArrowDown":
        case "ArrowUp":
          event.preventDefault();
          this.handleListOpen();
          break;
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Link Blur
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleLinkBlur = event => {
      const newTarget = event.relatedTarget;
    
      // If there's no new target (focus lost entirely),
      // or the new target is not inside this dropdown,
      // then close:
      if (!newTarget || !this._element.has(newTarget).length) {
        this.handleListClose();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Link Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleLinkKeydown = (event, option) => {
      switch (event.key) {
        case "Escape":
        case "Esc":
        case "Tab":
        case "Delete":
        case "Backspace":
          event.preventDefault();
          this.handleListClose();
          break;

        case "ArrowUp":
          event.preventDefault();
          var prevItem = $(option).prev().find('.a-dropdown__link');
          if (prevItem) prevItem.focus();
          break;

        case "ArrowDown":
          event.preventDefault();
          var nextItem = $(option).next().find('.a-dropdown__link');
          if (nextItem) nextItem.focus();
          break;

        case "Home":
          event.preventDefault();
          $(this._options[0]).find('.a-dropdown__link').focus();
          break;

        case "End":
          event.preventDefault();
          $(this._options[this._options.length - 1]).find('.a-dropdown__link').focus();
          break;

        default:
          this._searchQuery += event.key;

          const foundOption = this.handleListSearch(this._searchQuery);

          if (foundOption) foundOption.focus();

          if (this._searchTimeout) clearTimeout(this._searchTimeout);

          this._searchTimeout = setTimeout(() => {
            this._searchQuery = '';
          }, 1000);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Link Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleLinkClick = () => {
      this._element.removeClass("a-dropdown--open");
      this._list.hide();

      this._element.trigger('close', this);
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.dropdown = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].dropdown = new Dropdown(_[i], opt);
      else
        ret = _[i].dropdown[opt].apply(_[i].dropdown, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.a-dropdown').dropdown();
});